import Navbar from "../NavBar";
import Footer from "../Footer";

export default function Contact() {
  return (
    <section className="w-full bg-[#EFF2F3] text-gray-900 overflow-hidden">
      
      {/* Navbar */}
      <Navbar />

      {/* Header */}
      <div className="bg-[#C7D1D3] px-6 md:px-20 py-16">
        <h1 className="text-4xl md:text-6xl font-bold text-[#1b1d27]">
          How Can We Help?
        </h1>
      </div>

      {/* Content */}
      <div className="px-6 md:px-20 py-16">
        <h2 className="text-2xl md:text-3xl font-semibold mb-12 text-[#1b1d27]">
          I need to:
        </h2>

        <div className="grid md:grid-cols-2 gap-8">
          
{/* Card 1 */}
<div className="group relative overflow-hidden border border-gray-300 p-10 cursor-pointer
bg-gradient-to-r from-[#E4002B] to-[#E4002B] bg-[length:0%_100%] bg-no-repeat
hover:bg-[length:100%_100%] transition-all duration-300 ease-in-out">

  <div className="flex items-start gap-5 relative z-10">
    
    <div className="w-12 h-12 flex items-center justify-center border-2 border-red-500 rounded-full text-red-500 text-xl font-semibold group-hover:border-white group-hover:text-white transition-colors duration-300 ease-in-out">
      ?
    </div>

    <div>
      <h3 className="text-xl font-semibold flex items-center gap-3 group-hover:text-white transition-colors duration-300 ease-in-out">
        Request Support
        <span className="text-red-500 text-xl group-hover:text-white transition-colors duration-300 ease-in-out">→</span>
      </h3>

      <p className="text-gray-500 mt-4 leading-relaxed max-w-md group-hover:text-white transition-colors duration-300 ease-in-out">
        Get assistance with insurance claims, certificates,
        account or other support topics.
      </p>
    </div>
  </div>
</div>

{/* Card 2 */}
<div className="group relative overflow-hidden border border-gray-300 p-10 cursor-pointer
bg-gradient-to-r from-[#E4002B] to-[#E4002B] bg-[length:0%_100%] bg-no-repeat
hover:bg-[length:100%_100%] transition-all duration-300 ease-in-out">

  <div className="flex items-start gap-5 relative z-10">
    
    <div className="text-red-500 group-hover:text-white transition-colors duration-300 ease-in-out">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-10 h-10"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M17 20h5v-1a4 4 0 00-5-3.87M9 20H4v-1a4 4 0 015-3.87m8-2.13a4 4 0 10-6 0M9 10a4 4 0 11-6 0 4 4 0 016 0z"
        />
      </svg>
    </div>

    <div>
      <h3 className="text-xl font-semibold flex items-center gap-3 group-hover:text-white transition-colors duration-300 ease-in-out">
        Make a Business Inquiry
        <span className="text-red-500 text-xl group-hover:text-white transition-colors duration-300 ease-in-out">→</span>
      </h3>

      <p className="text-gray-500 mt-4 leading-relaxed max-w-md group-hover:text-white transition-colors duration-300 ease-in-out">
        Tell us more about you and how we can help your business make better decisions.
      </p>
    </div>
  </div>
</div>

        </div>
      </div>

      {/* Footer */}
      <Footer />
    </section>
  );
}